import {
  WeaDialog,
  WeaProgress,
  WeaInputSearch,
} from 'ecCom'

import {
  Row,
  Col,
  Spin,
} from 'antd'

import {
  WeaTableNew
} from 'comsMobx';
import React from 'react'
import {
  jumpToHrmDept,
  jumpToHrmPost,
  jumpToHrmJob,
} from '../../util/pulic-func'

const WeaTable = WeaTableNew.WeaTable;

class More extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      height: 510,
    }
  }

  reRenderColumns(columns, strokeColor) {
    columns.forEach((c, index) => {
      if (c.dataIndex == 'percent') {
        c.render = function(text, record) {
          let result = parseInt(record.result),
            max = parseInt(record.total);
          return <div>
  							      <WeaProgress 
  							      	percent={result/max*100} 
  							      	format={() => result}
  							      	strokeColor={strokeColor}
  							      />
  						    </div>
        }
      }
      if (c.dataIndex == 'departmentid') {
        c.render = (text, record) => {
          return <a onClick={() => jumpToHrmDept(record.departmentid)}>{record.departmentname}</a>
        }
      }
      if (c.dataIndex == 'title') {
        c.render = (text, record) => {
          // return <a onClick={() => jumpToHrmPost()}>{record.name}</a>
          return <span>{record.name}</span>
        }
      }
      if (c.dataIndex == 'mark') {
        c.render = (text, record) => {
          // return <a onClick={() => jumpToHrmJob()}>{record.mark}</a>
          return <span>{record.mark}</span>
        }
      }
    })
  }

  render() {
    const {
      title,
      visible,
      onCancel,
      buttons,
      search,
      tableStore,
      strokeColor,
    } = this.props;
    const {
      value,
      height
    } = this.state;

    return (
      <WeaDialog
  				title={title}
  				icon="icon-coms-hrm"
            	iconBgcolor="#217346"
            	visible={visible}
            	closable={true}
            	onCancel={() => { onCancel(); this.setState({value: ''}) } }
            	buttons={buttons}
            	style={{width: 870, height: 510}}
            	onChangeHeight={(h) => this.setState({height: h})}
  			>
  				<Row>
  					<Col span={10} offset={14}>
  						<div style={{textAlign: 'right', paddingTop: 10, paddingRight: 20}}>
  							<WeaInputSearch 
  								value={value}
  								onSearch={(v) => search(v)}
  								onSearchChange={(v) => this.setState({value: v}) }
  							/>
  						</div>
  					</Col>
  				</Row>
  				<Row>
  					<Col span={24}>
  						<div style={{padding: '10px 0'}}>
                <div style={{borderTop: '1px solid #E9E9E9'}}>
                    <WeaTable 
                      comsWeaTableStore={tableStore}
                      hasOrder={true}
                      scroll={{y: height-135}}
                      getColumns={c => {this.reRenderColumns(c, strokeColor);return c}}
                    />
                </div>
  						</div>
  					</Col>
  				</Row>
  			</WeaDialog>
    )
  }
}

export default More


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/components/report/More.js